import videojs from "./lib/video.js";
import { get, random } from "lodash-es";
import shared from "./js/_shared";

function a11y() {
    const player = this;
    player.one("ready", () => {
        const labelId = `label-${player.id()}-${random(0, 9999)}`;
        const labelEl = document.createElement("span");
        const playerEl = player.el();
        const media = shared._vjsEncode(playerEl.dataset.media, true);
        const visuallyHiddenStyles = `
            position: absolute;
            border: 0;
            clip: rect(0, 0, 0, 0);
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            overflow: hidden;
        `;
        labelEl.id = labelId;
        labelEl.innerText = get(media, "a11y.longDescription") || "";
        labelEl.setAttribute("tabindex", "-1");
        labelEl.setAttribute("style", visuallyHiddenStyles);
        playerEl.appendChild(labelEl);
        playerEl.setAttribute("aria-labelledby", labelId);
        playerEl.setAttribute("tabindex", "0");
    });
}

a11y.VERSION = "__1.0.0__";
videojs.registerPlugin("a11y", a11y);

export default a11y;
